// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 使用体验券开始模拟实盘交易 POST /strategy-simulate/coupon/create */
export async function strategySimulateCouponCreateUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategySimulateCouponCreateUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/strategy-simulate/coupon/create', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 开始模拟实盘交易 POST /strategy-simulate/create */
export async function strategySimulateCreateUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategySimulateCreateUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/strategy-simulate/create', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取仿真运算信息 GET /strategy-simulate/get */
export async function strategySimulateGetUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategySimulateGetUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStrategySimulateResp>('/strategy-simulate/get', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取模拟实盘通道信息 GET /strategy-simulate/passageways */
export async function strategySimulatePassagewaysUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategySimulatePassagewaysUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStrategyPassagewayStatisticsResp>(
    '/strategy-simulate/passageways',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取模拟实盘持仓 GET /strategy-simulate/position */
export async function strategySimulatePositionUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategySimulatePositionUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStrategyPassagewayTransactionOrderResp>(
    '/strategy-simulate/position',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取用户模拟实盘体验记录列表 GET /strategy-simulate/record/list */
export async function strategySimulateRecordListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategySimulateRecordListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStrategySimulationRecordResp>('/strategy-simulate/record/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 终止模拟实盘交易 POST /strategy-simulate/terminate */
export async function strategySimulateTerminateUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategySimulateTerminateUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/strategy-simulate/terminate', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
